module.exports = __webpack_public_path__ + "img/diamond-agility.1ceedf21.png";